import axios from '../base.js'
export default class WLTS {
  // 专属宽带排名
  static async reqGetzskdpmData() {
    let res = await axios.get('../data/WLTS/zskdpmData.json');
    return res.data;
  }
  // 专线类型占比
  static async reqGetzxlxzbData() {
    let res = await axios.get('../data/WLTS/zxlxzbData.json');
    return res.data;
  }
  // 网络性能
  static async reqGetwlxnData(p) {
    let res = await axios.get(`./data/WLTS/wlxnData${p}.json`);
    return res.data;
  }
  // 各省综合告警排名
  static async reqGetgszhgjpmData() {
    let res = await axios.get('../data/WLTS/gszhgjpmData.json');
    return res.data;
  }
  // 告警统计分析
  static async reqGetgjtjfxData() {
    let res = await axios.get('../data/WLTS/gjtjfxData.json');
    return res.data;
  }
  // 告警信息列表
  static async reqGetgjxxlbData() {
    let res = await axios.get('../data/WLTS/gjxxlbData.json');
    return res.data;
  }
}